export enum SuggestionSpace {
  Timesheet = 'Timesheet'
}

export * from './phase';
